export interface ScheduleColor {
  name: string;
  base: string;
  accent: string;
}

interface ScheduleColorMap {
  [key: number]: ScheduleColor;
}

export const ScheduleColors: ScheduleColorMap = {
  0: { name: 'Gray', base: '#F2F2F2', accent: '#B8B8B8' },
  1: { name: 'Misty Rose', base: '#FEDBDB', accent: '#F88585' },
  2: { name: 'Unbleached silk', base: '#FFDDCA', accent: '#F99576' },
  3: { name: 'Lumber', base: '#FFE4CD', accent: '#F9AD76' },
  4: { name: 'Corn Silk', base: '#FFF8DC', accent: '#F1BF78' },
  5: { name: 'Light Yellow', base: '#FFFDD0', accent: '#ECDA7B' },
  6: { name: 'Pomelo', base: '#F9FFE3', accent: '#B6D08C' },
  7: { name: 'Nyanza', base: '#E9FFDB', accent: '#A6D08C' },
  8: { name: 'Honeydew', base: '#F0FFF0', accent: '#8CD0A3' },
  9: { name: 'Aero Blue', base: '#C9FFE5', accent: '#67C697' },
  10: { name: 'Green Cyan', base: '#D4FFF2', accent: '#6ECEB1' },
  11: { name: 'Light Cyan', base: '#E0FFFF', accent: '#7AD9DD' },
  12: { name: 'Water Light', base: '#E1F7FC', accent: '#5ABCD1' },
  13: { name: 'Alice Blue', base: '#F0F8FF', accent: '#5AA6D1' },
  14: { name: 'Lavender Mist', base: '#E6E6FA', accent: '#8E99D3' },
  15: { name: 'Magnolia', base: '#F8F4FF', accent: '#C6AFED' },
  16: { name: 'Sweat Dreamer', base: '#EFDDFB', accent: '#AC8ED3' },
  17: { name: 'Pale Purple', base: '#FAE6FA', accent: '#DAB2E8' },
  18: { name: 'Magenta Light', base: '#FFE3FE', accent: '#E19EDF' },
  19: { name: 'Pink Lace', base: '#FFDDF4', accent: '#ED9AC7' },
  20: { name: 'Piggy Pink', base: '#FDDDE6', accent: '#F892AD' },
};
